import { baseThemeValues } from 'constants/common';

const labelFont = {
  fontFamily: baseThemeValues.inherit,
  fontSize: '11px',
  fontWeight: 600,
};

const bodyFont = {
  fontFamily: baseThemeValues.inherit,
  fontSize: '13px',
  fontWeight: 400,
};

// `value` is a reserved leaf-wrapper key in composeTheme, so the big-number font is `figure`.
const cardBaseProps = {
  borderRadius: '8px',
  borderWidth: '1px',
};

export const terminalLinkHealthTheme = {
  card: {
    base: {
      ...cardBaseProps,
      bg: 'palette.surface.3',
      borderColor: 'palette.surface.5',
    },
    fallback: {
      ...bodyFont,
      fontWeight: 500,
      text: 'palette.tertiary.60',
    },
    figure: {
      fontFamily: baseThemeValues.inherit,
      fontSize: '22px',
      fontWeight: 700,
      text: 'palette.tertiary.95',
    },
    label: {
      ...labelFont,
      text: 'palette.tertiary.60',
    },
    meta: {
      ...bodyFont,
      fontSize: '12px',
      text: 'palette.tertiary.60',
    },
    row: {
      ...bodyFont,
      text: 'palette.tertiary.90',
    },
    rowMuted: {
      ...bodyFont,
      text: 'palette.tertiary.60',
    },
    rowStrong: {
      ...bodyFont,
      fontWeight: 600,
      text: 'palette.tertiary.95',
    },
    separator: {
      bg: 'palette.tertiary.30',
      height: '1px',
      verticalGap: '0px',
    },
    title: {
      ...bodyFont,
      fontSize: '14px',
      fontWeight: 600,
      text: 'palette.tertiary.95',
    },
    unit: {
      ...bodyFont,
      fontWeight: 500,
      text: 'palette.tertiary.60',
    },
  },
  subtitle: {
    ...bodyFont,
    text: 'palette.tertiary.60',
  },
};
